import * as React from 'react';
import { compose, mapProps } from 'recompose';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form/immutable';
import { createStructuredSelector } from 'reselect';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { InjectedFormProps } from 'redux-form';
import { fromJS } from 'immutable';

import { withModal } from '../../../modules/modal/withModal';
import { getExpectedWordsCount } from '../selectors';
import FormField from 'src/components/Form/FormField';
import FormInput from 'src/components/Form/FormInput';
import Button from 'src/components/Button';

import './styles.scss';
import * as userProfileActions from '../actions';

interface IConnectedProps {
  wordsGoal: number;
}

interface ActionProps {
  submitChangeWordsGoalForm: typeof userProfileActions.submitChangeWordsGoalForm;
}

const translationsScope = 'containers.UserProfile.ChangeWordsGoalModal';

class ChangeWordsGoalModal extends React.Component<
  IConnectedProps & ActionProps & InjectedIntlProps & InjectedFormProps
> {
  public render() {
    const {
      handleSubmit,
      valid,
      intl: { formatMessage },
    } = this.props;
    return (
      <div className="ChangeWordsGoalModal">
        <div className="ChangeWordsGoalModal-title">{formatMessage({ id: `${translationsScope}.title` })}</div>
        <form action="#" className="ChangeWordsGoalModal-form" onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            name="wordsGoal"
            component={FormField as any}
            InputComponent={FormInput}
            label="Words Goal"
            type="number"
            validate={this.validate}
            withErrorBelow={true}
          />
          <div className="ChangeWordsGoalModal-actions">
            <Button type="submit" block={true} disabled={!valid}>
              {formatMessage({
                id: `${translationsScope}.submit`,
              })}
            </Button>
          </div>
        </form>
      </div>
    );
  }

  private onSubmit = () => {
    const {
      submitChangeWordsGoalForm,
      intl: { formatMessage },
    } = this.props;

    submitChangeWordsGoalForm(
      formatMessage({
        id: `${translationsScope}.changeWordsGoalSuccess`,
      }),
    );
  };

  private validate = (wordsGoal: number) => {
    const {
      intl: { formatMessage },
    } = this.props;

    if (wordsGoal < 100 || wordsGoal > 10000) {
      return formatMessage({ id: `${translationsScope}.wrongWordsGoalRange` });
    }
    return null;
  };
}

export const CHANGE_WORDS_GOAL_MODAL_NAME = 'changeWordsGoal';

const enhance = compose(
  withModal({
    modalName: CHANGE_WORDS_GOAL_MODAL_NAME,
  }),
  injectIntl,
  connect<IConnectedProps, ActionProps, InjectedIntlProps>(
    createStructuredSelector({
      wordsGoal: getExpectedWordsCount,
    }),
    userProfileActions,
  ),
  mapProps((props: IConnectedProps & InjectedIntlProps) => {
    return {
      ...props,
      initialValues: fromJS({
        wordsGoal: props.wordsGoal,
      }),
    };
  }),
  reduxForm({
    form: CHANGE_WORDS_GOAL_MODAL_NAME,
  }),
);

export default enhance(ChangeWordsGoalModal);



// WEBPACK FOOTER //
// ./src/containers/UserProfile/ChangeWordsGoalModal/index.tsx